import type { FaireProductEntity } from "../../entity_types/product";

export const p_u9njs9g9q8: FaireProductEntity = {
  token: "p_u9njs9g9q8",
  type: "product",
  name: "Women's Fuzzy Crew Socks with Grippers - Holiday Gift",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/f64b9242e1223d99d4624b32ff0f4a030fd1b1b98ba2b66f65da06a2f4e40eb4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c9905575e1e1836e00c892da374cabb2c2e1356fdedd455a714bd1f8e34a7daf.png",
    "https://cdn.faire.com/fastly/33a90515fda735ebde0c72f5936827aa255d174bd7844ef52d8fb9ad7abb31cd.png",
    "https://cdn.faire.com/fastly/2369186a6868135b2d4b17ca03f6cc74508a9b9a1bb3655f8628bfcec687d873.png"
  ],
  priceDollars: 13,
  description: "Step into comfort with our signature Marshmallow Crew Socks, crafted from decadently soft fabric with delicate ribbing for a cozy feel. No-slip gripper bottoms make them perfect for lounging at home, while their giftable appeal makes them an easy choice for holiday gifting, and everyday self-care.\n\nOur signature Marshmallow fabric makes them decadently soft, making it the perfect gift for just about anyone–especially expectant mothers. Kick up your feet in a pair of socks you’ll never want to take off.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Crew length\n• Non-slip grippers\n• Cozy Marshmallow fabric",
  tags: [],
  msrpDollars: 26,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:46:59.295Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
